var map = {
	"./404.png": "8f20",
	"./categories.png": "a0fa",
	"./dashboard.png": "67e5",
	"./favicon.png": "a171",
	"./logo.png": "4ffd",
	"./logo_tipo.png": "6cf0",
	"./logo_white.png": "0bc8",
	"./mercadopago.png": "9c98",
	"./orders.png": "e85f",
	"./pagseguro.png": "3bc4",
	"./photo_upload.png": "032a",
	"./stock.png": "1be3",
	"./stores.png": "f05b",
	"./stores1.png": "bbdd",
	"./web.png": "5a8d",
	"./yapay.png": "347f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";